import { market } from "../market/ja_JP";
import { invite } from '../invite/ja_JP';
import { property } from '../property/ja_JP';
import {advertise} from '../advertise/ja_JP';
import {login, download} from '../login/ja_JP';
import {trading} from '../trading1/ja_JP';
import {contest} from '../contest/ja_JP';
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/ja_JP";
import { games } from '../games/ja_JP';
import { taskCenter } from "../task/ja_JP";
import { ieo } from "../ieo/ja_JP";
import { earn } from "../earn/ja_JP";
import { apis } from "../api/ja_JP";
import { tradingContest } from "../tradingContest/ja_JP";
import { agent } from "../agent/ja_JP";
import { live } from "../live/ja_JP";
import { hongbao } from "../hongbao/ja_JP";
const time = {
  r: "日",
  s: "時",
  f: "分",
  m: "秒",
};

const state = {
  preheatIng: "発売待ち",
  purchaseIng: "購入中",
  over: "終了",
  finish: "完了",
  noData: "データなし",
  process: "助力中",
  sellout: "売り切れ",
};

const text = {
  now: "進行中",
  start: "開始まで",
  end: "終了まで",
  jd: "進捗",
  complete: "完了",
  limited: "限時割引価格",

  finish: "完了",
  subscribing: "購入申し込み中",
  subscribeNow: "今すぐ購入",
  buyStart: "購入申し込み開始まで",
  buyEnd: "購入申し込み終了まで",
  projectAmount: "プロジェクトの数量",
  quota: "1口あたりのクォータ",
  buyPrice: "購入申し込み価格",
  buyLimit: "購入申し込み制限",
  buyAmount: "購入申し込み数量",
  buyPos: "購入申し込み通貨のポジション",
  startDate: "開始日時",
  endDate: "終了日時",
  projectSuppot: "プロジェクトサポート",
  websit: "プロジェクトウェブサイト",
  projectDetail: "プロジェクト詳細",
  cycle: "購入サイクル",
  all: "すべて",
  step1: "開始待ち",
  step2: "購入申し込み",
  step3: "抽選",
  step4: "結果公表",
  subOrder: "購入申し込み注文",
  myOrder: "当選注文",
  proCoin: "プロジェクト通貨",
  buyCoin: "購入申し込み通貨",
  orderDate: "注文日時",
  issuanceQuota: "発行クォータ",
  dealAmount: "取引数量",
  dealPrice: "取引金額",
  status: "ステータス",
  ctrl: "操作",
  checkOrder: "当選番号を確認",
  subNum: "購入申し込み番号",
  myNum: "当選番号",
  status0: "購入申し込み済み",
  status1: "引き落とし待ち",
  status2: "完了",
  conditionTerm1: "購入申し込み開始前*日、",
  conditionTerm2: "取引ペア*",
  conditionTerm3: "すべての取引ペア",
  conditionTerm4: "現物取引の合計金額（USDT）が累計*に達するごとに1口購入できます",
  noData: "データなし",
  qgsc: "ロック購入",
  yhsg: "抽選購入申し込み",
  sgsb: "購入申し込み失敗",

  supply: "本サイクルクォータ",
  rate: "交換比率",
  ceiling: "助力上限",
  xmwc: "プロジェクト完了",
  xmze: "プロジェクト総額",
  zkjj: "ディスカウント平均価格",
  cyrs: "参加者数",
  round: "第[*]ラウンド",
  r: "人",
  cgqg: "購入成功",
  cgzl: "助力成功",
  xmed: "プロジェクトクォータ",
  kszl: "助力開始時間",
  ksqg: "購入開始時間",
  jsqg: "購入終了時間",
  jszl: "助力終了時間",
  hdgz: "イベントルール",
  xmjs: "プロジェクト紹介",
  tcqr: "支払いを退出すると、この購入イベントのチャンスを失う可能性があります。操作に注意してください！",
  jxtc: "辞退続行",
  fhzf: "支払いに戻る",
  qgrsd: "現在の購入者が多いため、購入が進行中です。しばらくお待ちください！",
  zltcqr: "支払いを退出するとと、この助力イベントのチャンスを失う可能性があります。操作に注意してください！",
  zlqgrsd: "現在の助力者が多いため、お待ちください！",
  wxts: "注意：お早目に支払いを確認してください。[*]分以内に支払いが完了しない場合、支払いがタイムアウトしてウィンドウが閉じられます。",
};
const seckill = {
  sgno: "購入申し込み条件を満たしていません",
  srjymm: "取引パスワードを入力してください",
  ljzf: "今すぐ支払う",
};

const apply = {
  condition: "購入申し込み条件",
  apply: "今すぐ申し込む",
  buyPrice: "購入申し込み価格",
  buyAmount: "購入申し込み数量",
  applyAmount: "購入申し込み金額",
  forget: "取引パスワードをお忘れですか？",
  noAmount: "購入申し込み数量を入力してください",
  buyLimit: "申し込み制限額",
  success: "申し込みが成功しました！",
    paySummary:"ご注意：支払いお支払いをお早目に行ってください。<b>3分以内</b>に支払いが完了しない場合、支払いはタイムアウトしてウィンドウが閉じられます。",
  appFull: "申し込み数量が大きすぎます",
  seckill_async_fail_13: "2回の申し込みの間隔は{}分です",
};

const seckillRes = {
  seckill_async_3: "支払い中です。しばらくお待ちください。",
  seckill_async_5: "キャンセルが成功しました",
  seckill_async_fail_1: "申し訳ありません！ページを更新して、再試行してください。",
  seckill_async_fail_2: "申し訳ありません！ページを更新して、再試行してください。",
  seckill_async_fail_3: "申し訳ありません！ページを更新して、再試行してください。",
  seckill_async_fail_4: "申し訳ありません！枠がなくなってしまいました。",
  seckill_async_fail_5: "申し訳ありません！支払いがタイムアウトしました。再試行してください。",
  seckill_async_fail_6: "支払いパスワードが間違っています。もう一度入力してください。",
  seckill_async_fail_7: "支払いパスワードの試行回数が制限を超えました。しばらくしてからもう一度お試しください。",
  seckill_async_fail_8: "申し訳ありません！支払いがタイムアウトしました。再試行してください。",
  seckill_async_fail_9: "申し訳ありません！枠がなくなってしまいました。次回の成功をお祈りいたします。",
  seckill_async_fail_10: "現在、多くの申し込みが混み合っております。しばらくお待ちください。",
  seckill_async_fail_11: "認証が失敗しました！",
};

const header = {
  zcgl: "資産管理",
  zczh: "資産口座",
  bbzh: "現物口座",
  fbzh: "コイン購入口座",
  bdbzh: "コインレンディング口座",
  wdgl: "注文管理",
  lswt: "過去の注文",
  qbhz: "ウォレット間の送金",
  yhzx: "マイページ",
  wdhb: "私のラッキーマネー",
  openOrder: "現在の注文",
  dealStats: "成約統計",
  totalAsset: "総資産評価額",
  cz: "先物口座",
  gmcnyt: "CNYT購入",
  yqfy: "招待",
  hbthhr: "HBTパートナー",
  tczh: "アカウントをログアウト",
  moreNew: "その他のアナウンスメント",
  gfgg: "公式アナウンスメント",
  zxxw: "最新ニュース",
  ckgd: "詳細を表示",
  bbdd: "現物注文",
  bbwhydd: "コイン本位ペア無期限先物注文",
  etfdd: "ETF注文",
  fbdd: "法定通貨注文",

};
const recommend = {
  vol24h: "24時間の出来高",
  jyd: "取引ペア",
  jydlx: "取引ペアのタイプ",
  zxj: "最新価格",
  change24: "24時間の変動",
  line24: "価格トレンド（3日間）",
};

const hyy = {
    ty: "同意します",
  bkt: "未開通",
  wqdkt: "開通を確認する",
  kt12: "1. 参加する前に、デジタル通貨の先物取引に関する基本知識や関連するリスク、およびデリバティブ取引に関連する事業ルールなどを十分に理解してください。",
  kt13: "2. 上記のリスク事項は一部の例示であり、デジタル資産のデリバティブ取引に関連するすべてのリスク要因を網羅しているわけではありません。投資家はデジタル資産のデリバティブ取引に参加する前に、他の潜在的なリスク要因も理解し、把握する必要があります。",
  kt14: "3. 投資家の皆様には、リスク耐性などの実際の状況に基づいて、こ先物取引に参加するかどうかを慎重に判断し、デジタル資産を合理的に配置することをお願いいたします。",
  kt0: "尊敬するユーザー様へ:",
  kt1: "先物口座および先物取引権限がまだ開通されていないため、以下の内容をご確認いただいた後に開通するかどうかを決定してください。",
  kt2: "1.  先物取引市場で取引を行う場合、市場価格の動向が不利になり、ポジションの証拠金が不足すると、BiKing無期限先物はシステムに従ってポジションを強制的に清算し、清算の詳細を公開することになります。",
  kt3: "2.  BiKing無期限先物の業務ルールを熟読し、先物のメカニズムと運用原理、市場の様々なリスクに関する知識を深く理解してください。",
  kt4: "4.  BiKing無期限先物は先物取引システムを提供しており、ユーザーのポジションの損益は先物市場の価格変動に応じて変化します。損失が大きい場合、先物取引システムはロスカットを行う可能性があります。ユーザーの方は、先物市場の状況に基づいて自身の取引行動を適切に判断し、自己の損益を負うことになります。このため、BiKingは一切の保証責任を負いません。",
  kt5: "5.  ユーザーは、プラットフォームの関連規則を守ることと、関連する国または地域の法律法令を自主的に遵守することを自己の責任でお願い申し上げます。ユーザーが先物口座を不正操作するなどの行為が発生した場合、口座が凍結され、ユーザーが操作できなくなる可能性があります。また、プラットフォームはユーザー代わりに清算を実施することはできません。これにより生じる損失またはロスカットについて、プラットフォームは一切の責任を負いません。",
  kt6: "6.  デジタル資産のデリバティブ取引は、一部の法律の政策監督リスクに直面する可能性があります。お客様は、取引地域の政策監督の背景を十分に理解したうえで、取引を慎重に判断する必要があります。関連する国や地域の法律、法令、政策の変更、先物取引所の取引ルールの変更、緊急対策などにより、BiKingは事前に声明を発表することがあります。お客様が保有する未清算の先物が続行できなくなる可能性がありますが、証拠金と利益は清算されて出金できます。",
  kt7: "7.  プラットフォームが制御できない理由により、注文が成立しないか、またはすべての注文が成立しない可能性があります。例えば、地震、水害、火災などの不可抗力の要因や、コンピューターシステム、通信システムの障害などが挙げられます。これによる損失は、お客様ご自身が負担する可能性があります。",
  kt8: "8.  「ヘッジ取引」も投機取引と同様に、価格の変動によるリスクに直面する可能性があります。",
  kta9: "9.本人確認が完了していない場合、またはGoogle認証が登録されていない場合、または他人にアカウントを貸し出して操作された場合、先物証拠金の安全性に影響を及ぼす可能性があります。",
  kta10: "3. 一部の極端な市場状況では、保有する未清算先物を清算することが難しいか、またはできない場合があります。たとえば、お客様の利益が全体の先物市場での有効なレバレッジPnLの中で第一位に位置し、対手盤が保険基金で穴埋めする余裕がない場合です。",
  kt9: "私は注意深く内容を読み、理解し、リスクを受け入れます",
  kt10: "先物口座および先物取引権限を開通する",
  zjhz: "資金振替",
  ljhz: "今すぐ振替",
  qx: "キャンセル",
  khz: "振替可能",
  qxz: "選択してください",
  bz: "通貨",
  c: "元",
  zz: "転送先",
  sl: "数量",
  qb: "すべて",
  ktcg: "開通成功",
  ktsb: "開通失敗",
  hzcg: "振替成功",
  hzsb: "振替失敗",
  wyyd: "", //未チェックの既読テキスト
  tc: "閉じる",
  warning1: "通貨を選択してください",
  warning2: "振替元口座を入力してください",
  warning3: "振替先口座を入力してください",
  warning4: "振替可能数量を超えない数値を入力してください",
  warning5: "最大で小数点以下4桁まで入力可能です",
  gb: "閉じる",
  openSuccess: "先物取引が開通しました",
  openSuccessTip: "資金を先物口座に振替してください",
  wsmyz: "まだ本人確認が完了していません",
  hdnm: "本人確認を完了し、累計で[*]USDT以上を先物口座に振替すると、[**]USDTの泥コードを獲得できます",
  nmjl: "泥コードの記録",
  nmhzjl: "泥コード贈与記録",
  gxn: "おめでとうございます!",
  qwjy: "取引へ",
  yfrndhyzh: "先物口座に送信されました",
  nzxy: "先物口座に[*]USDT振替すると、[**]USDTの泥コードを獲得できます",
  nmssm: "泥コードとは",
  nm: "泥コード",
  nxhyzh: "先物口座に",
  text1: "先物口座に累計に[*]USDT以上を振替すると、",
  text2: "先物口座に[*]USDTを振替するだけで",
  text3: "[*]USDTの泥コードが獲得できます",
  text4: "残高",
  text5: "先物口座に累計に[*]USDT以上を振替しました。すでに獲得されています",
  not_get_nm: "申し訳ありません、泥コードイベントは終了しました。この振替では泥コードを獲得できませんでした",
  yijie: "1段階",
  erjie: "2段階",
  ljjhr: "累計振替入金額",
  khd: "獲得可能",
  hysnm: "先物で泥コード獲得",
  bbgg: "無期限先物 レバレッジ100倍",
  hdsj: "イベント期間：",
  hdxq: "イベント詳細",
  ljhd: "今すぐ受け取る",
  xdxd: "先着順",
  ylnnz: "勝ったらもらえる、負けてもこちら持ち",

};

const Verification = {
  channel: "公式認証チャネル",
  verify: "認証情報を入力してください",
  notes: "セキュリティに関する注意事項",
  notes1: "1. BiKingに関連するすべてのメールアドレス、WeChatアカウント、QQ番号、ドメイン名、メディアアカウントは、こちらで認証できます。",
  notes2: "2. ソーシャルメディアアカウント（Weibo、Twitterなど）は、名前の検索するだけ対応します、大文字と小文字を区別する必要があります。",
  notes3: "3. 認証結果に疑問がある場合は、公式ウェブサイトまたはアプリ内で公式カスタマーサポートに連絡して再確認してください。",
  error: "認証失敗",
  error1: "あなたが検索した情報",
  error2: "は公式認証チャネルではありません、資産の安全性を保護し、個人情報が漏洩する可能性に注意してください。",
  errorNote: "注意事項",
  errorNote1: "1. 現在の公式認証チャネルは、メールアドレス、公式WeChatアカウント、QQ番号、ドメイン名、ソーシャルメディアアカウントに対してのみ対応しています。",
  errorNote2: "2. WeChatなどのチャットツールは、アカウント（ニックネームではない）でのみ検索できます。",
  errorNote3: "3. ソーシャルメディアアカウントは、名前でのみ検索でき、大文字と小文字を区別する必要があります。",
  success: "認証成功",
  success1: "あなたが検索した情報：",
  success2: "はBiKing公式認証です",
  success3: "ただし、同じ情報が他のチャネルで出現する場合、信頼できないものとし、資産の安全に注意してください。",
  more: "詳細を見る",
  know: "分かりました",
  weChat: "WeChat",
  name: "ドメイン名",
  webo: "Weibo",
  twitter: "Twitter",
  email: "メールアドレス",
  contact: "カスタマーサポートに連絡する",
  bannerTip: "詐欺グループがBiKingの名前を利用して詐欺行為を行うのを防ぐため、このページでお使いの電話番号やWeChatなどがBiKing公式チャネルであることを確認できます。",

};

const index = {
  downloadIos: 'AppStoreからダウンロード',
  downloadAndroid: 'Androidでダウンロード',
  downloadGoogle: 'Google Playでダウンロード'
};

const indexPage = {
  gfgg: "公式アナウンスメント",
  zxxw: "最新ニュース",
  ckgd: "もっと見る",
};
const NAVS = {
    xh: '現物取引',
    hhjy: 'スワップ取引',
  ty: 'たいいく',
  hqsj: '相場 (そうば)',
  game: 'ゲーム',
  fx: '発見',
  sj: 'データ',
  fb: 'コイン購入',
  bb: '現物取引',
  jr: "ファイナンス",
  jyds: "トレーディングコンテスト",
  hbhd: "レッドパケットイベント",
  gg: 'レバレッジ取引',
  yxhy: '無期限先物',
  eft: 'ETF取引',
  flhd: '特典イベント',
  flzx: '特典',
  fast: 'クイック取引',
  spec: 'プロトレード',
  login: 'ログイン',
  rig: '登録',
  downapp: 'BiKingアプリをダウンロード',
  downappsum: 'スムーズな体験、瞬時の入出金',
  zichan: '資産',
  order: '注文',
  qbhz: 'ウォレット間の転送',
  lang: '言語',
  calc: '評価方法',

  mb: 'コイン購入',
  hq: '市場',
  hy: '先物',
  jy: '取引',
  lc: 'コイン獲得',
  fs: 'Fansup',
  xy: 'アカデミー',
  byxy: 'BiKingアカデミー',
  byyx: 'BiKing厳選',
  coins: 'COINSポイント',
  gd: 'その他',
  yqhy: '友達を招待',
  rwzx: 'タスクセンター',
  bbms: 'USDTでビットコインなどのデジタル資産を購入',
  ggms: 'プラットフォーム上でデジタル資産を貸し出し、リターンとリスクを最大化',
  yxms: '最大100倍のレバレッジ取引、使いやすい操作',
  etfms: 'リターンを最大化、ロスカットリスクなし',
  pool: '共有マイニングプール',
  czzn: '操作ガイド',
  gywm: '当社について',
  zhxx: '口座情報',
    gd:"コビートレード",
  yxhy: '無期限先物',
  zjhy: 'ボーナス先物',
  product: "製品",
};

const FOOTERS = {
  zxkf: 'オンラインカスタマーサポート',
  fawu: '法律アドバイス',

  us: '私たちについて',
  product: '製品',
  service: 'サービス',
  college: '学習',

  aboutUs: '私たちについて',
  rateSum: '料金説明',
  notices: 'アナウンスメントセンター',
  helps: 'ヘルプセンター',
  verific: '公式認証チャネル',
  contact: 'お問い合わせ',

  fabi: 'コイン購入',
  bibi: '現物取引',
  ganggan: 'レバレッジ取引',
  swiper: '無期限先物',
  etf: 'ETF取引',
  licai: 'コイン獲得',

  apis: 'API対応',
  apisNew: 'API対応',
  addCoin: 'コイン上場申請',
  vips: 'VIP特典',
  downapp: 'アプリダウンロード',
  files: '法的文書',

  newuser: 'BiKing初心者キャンプ',
  swiperSchool: '先物アカデミー',
  assistant: '学習アシスタント',
  digitalintroduction: 'デジタル資産紹介',

  watchword: '世界級のグリーンな取引プラットフォーム',
  meiyitian: '毎日、富を創出',
  chat: 'チャットルーム',
  shequncn: 'Telegram中国語コミュニティ',
  shequnen: 'Telegram英語コミュニティ',
  shequnkr: 'Telegram韓国語コミュニティ',
};

const SIDEBAR = {
  newuser: '初心者',
  guide: 'ガイド',
  bbsq: '現物コミュニティ',
  hysq: '先物コミュニティ',
  gd: '固定',
  sq: '非表示',
};
const banner = {
  wzwh: 'Bikingウェブサイトを使用したり、アカウントを維持したりすることは、私たちの更新された',
  sytk: '利用規約',
  yszc: 'プライバシーポリシー',
  hh: 'および',
  cookie: 'Cookieポリシー',
  djgb: '「X」をクリックすると、上記の利用規約とポリシーに同意したことになります。',

  title: '多様なゲームと暗号通貨取引プラットフォーム',
  marketTitle: '暗号通貨取引、私たちはプロです',
  marketSubTitle: '安全で安定した暗号資産デリバティブ取引サービスを提供することを目指しています',
  pathTitle: 'あなたの暗号通貨の旅の頼りになるパートナー',
  pathSubTitle: '数千万のユーザーが選ぶ、信頼できるプラットフォーム',
  jylz: '3000億ドル',
  jyl: '72時間の取引量',
  sxs: '暗号通貨が上場済み',
  zcyh: '登録ユーザー',
  zdjy: '最低取引手数料',
  connectTitle: 'なぜ私たちを選ぶべきか',
  connectSubTitle: 'BiKingは、財富を創造、増加、保護するのをサポートします',
  advantageText1: '最高のパフォーマンス · 高速取引',
  advantageSubText1: 'ロンドン証券取引所の技術駆動、超低遅延、高速マッチング',
  advantageText2: '資産保護 · 最高のセキュリティ',
  advantageSubText2: 'BikingはCCSS基準に準拠し、資産とデータの安全性を保証',
  advantageText3: '高流動性 · 低スプレッド',
  advantageSubText3: 'Bikingの契約レバレッジ取引は超高効率、最小スリッページ',
  advantageText4: '24時間体制のサービス',
  advantageSubText4: 'システムの正常動作を保証し、24時間体制のカスタマーサービスを提供',
  advantageText5: '使いやすさ',
  advantageSubText5: 'さまざまな注文システムと取引ツールを提供し、リスクをコントロール',
  advantageText6: 'いつでもどこでも安心して取引',
  advantageSubText6: 'Web版、モバイルアプリ、API、FIX接続を提供するBikingプラットフォーム',
  netWorkTitle: '26か国、120万人以上のユーザーが選ぶ',
  netWorkSubTitle: '安全で安定した暗号資産デリバティブ取引サービスを提供することを目指しています',
  smxz: 'QRコードをスキャンしてダウンロード',
  fxbzj: 'リスク保証金',
  fkbz: 'すべての取引に万全の資金リスクコントロール保護を提供',
  question1: '1. Biking交易所の紹介',
  questionContent1: 'Biking交易所は、世界をリードするシンガポールのデジタルアセット取引プラットフォームで、アメリカとカナダのMSBライセンスを保有し、さまざまなデジタルアセットの取引、保管、管理などのサービスを提供しています。',
  question2: '2. Biking交易所はどのような製品を提供していますか？',
  questionContent2: 'Biking交易所は以下の製品を提供しています：永続契約 - ディープレベル、ミリ秒マッチング；スポット取引 - 手数料0、高速約定；コピートレーディングコミュニティ - 経験豊富なトレーダー、安定した戦略トレード；ボーナストレード - 特有のモデル、さまざまな特典；Webウォレット - 分散型のワンストップサービス',
  question3: '3. Biking交易所への登録方法は？',
  questionContent3: 'Biking交易所の公式ウェブサイトまたはBikingアプリで登録できます。登録をクリックして、登録プロセスを完了して、Biking交易所を使用して暗号資産の投資と資産管理を始めることができます。',
  question4: '4. Biking交易所を通じて暗号資産を購入する方法は？',
  questionContent4: 'Biking交易所のクイックバイコイン機能は、さまざまな支払い方法と法定通貨をサポートし、世界中のユーザーに多くの選択肢と利便性を提供します。どの国または地域からのユーザーでも、ローカル通貨で簡単に暗号資産を購入することができます。',
  question5: '5. 暗号資産取引の方法は？',
  questionContent5: 'Biking交易所で取引したい暗号資産を選択し、取引ページに移動して、購入または売却を選択し、取引数量と価格を入力し、取引を確定します。また、ビットコイン、イーサリアム、ライトコイン、リップルなど、さまざまな暗号資産の取引をサポートしています。',
  question6: '6. Biking交易所はどのようにユーザーの資産を保護していますか？',
  questionContent6: 'Biking交易所は、多層の暗号化技術を使用してユーザーの情報と資産の安全性を保護し、ホットウォレットとコールドウォレットの分離されたストレージ方式を採用し、ユーザーの資産の安全性を確保しています。',
  investor: '300万の暗号資産投資家の信頼',
  transaction: 'BIKingでの投資、取引、成長',
  hypt: 'グローバルな安全リーダーのデジタルアセット契約取引プラットフォーム',
  yjpc: 'クリック一つでオープン/クローズ',
  jscrj: '高速入出金、60秒で取引を開始し、ゼロスリッページ取引を実現',
  zcpt: '登録取引でUSDTを受け取る',
  email: 'メールアドレス',
  phone: '電話番号',
  zc: '登録',
  yhjaqbz: '銀行レベルのセキュリティ保障',
  lhdmch: 'ゼロスリッページ秒マッチング',
  qthkf: '24時間体制のカスタマーサポート',
  rmjmhb: '人気の暗号通貨',
  jrsq: '参加するBikingコミュニテ',
  hqzxhd: '最新のサイクリング イベント情報とオンライン サポートを入手する',
}

const navCard = {
  join: 'BiKingに参加',
  hzdl: 'BiKingビーキングの提携代理契約がご参加をお待ちしております',
  jmrx: '代理加盟ホットライン：183283232998',
  contract: 'Contract online',
  yxhy: '高速先物、BiKingビーキングダブル先物が登場',
  jylh: '柔軟な取引、豊かな収益',
  usa: '米国およびカナダMSB',
  zmjys: '海外で有名な取引所、BiKingビーキングが多国からライセンス認証を取得',
  fxpf: 'リスクは保証されます、安全で信頼性の高い',
  srhy: '初めての先物取引で30%のリアルマネーをプレゼント',
  hdsj: 'イベンド期間：2022年11月01日0時〜2022年12月01日0時'
}

const choice = {
  gjyh: '26か国、120万人以上のユーザーが選んでいます',
  jyfu: '安全で安定したデジタル資産デリバティブ取引サービスを提供することに努めます',
  wsmxzwm: 'なぜ私たちを選ぶべきか',
  jsty: '高速体験',
  jmsj: '取引画面のデザインは、プラットフォームの長年のユーザーオペレーション経験と組み合わされ、プロセスがわかりやすく、操作が簡単で、さらにミリ秒単位のコアメモリマッチング技術で、ユーザーに便利で快適な取引体験を提供しています。',
  kfx: 'リスク耐性価格メカニズム',
  pthybz: 'プラットフォーム先物コイン価格は、多源指数統合アルゴリズムを使用しており、強力なリスクコントロール能力を備えており、市場の急激な変動から生じるユーザーのリスクと損失を効果的に回避しています。',
  zjaqbz: '資金安全保証',
  zjdt: 'すべての資金の動きは、複数のオフライン署名で実行され、ミリ秒単位で判断が行われ、ディープコールドストレージで資金が保管され、ユーザーの資金安全を全面的にサポートし、すべてのユーザーに銀行レベルの100%のセキュリティとリスクコントロールを提供します。',
  jszc: 'トップクラスのテクニカルサポート',
  ptjstd: 'プラットフォームの技術チームは、トップレベルのブロックチェーン技術専門家から結成し、ユーザーの最高の体験を保証し、プラットフォームの開発と運用に強力な技術サポートを提供しています。',
  jcjz: '段階的なポジションクローズメカニズム',
  hqbh: '市場の状況に応じて、ユーザーのトレードリスクメカニズムを適切にトリガーし、24時間体制でユーザーの資産を保護します。',
  kf: '24時間カスタマーサポート',
  ptkf: 'プラットフォームは24時間シフト制でカスタマーサポートサービスを提供し、ユーザーが直面するすべての問題に真摯に対応します。',

}

const plat = {
  ptgn: 'プラットフォームの機能',
  zjms: 'ボーナスモード',
  zjjs: 'ボーナスモードは、BiKingチームが全ウェブ契約ユーザー向けに導入した特長的な先物取引方式です。贈金モードの操作手順は、実際の先物と同じであり、ポジション取得での利益の一部は先物に転送され、新たな取引または直接引き出しに使用されます。収益の獲得方法には、手数料のリアルタイム返金、キャンペーンエアドロップ、タスクの完了などが含まれます。',
  zcms: 'クロスポジションモード',
  zcjs: 'クロスポジションモードでは、すべてのポジションの保証金とフローティングプロフィット/ロスは相互に統合され、ポジション取得の保証金を含むすべての口座資産がフローティング保証金として機能します。クロスポジションモードは強力なリスクコントロール能力を備えており、市場の急激な変動に対しても予想以上のリスクを回避できますが、逆に予想以上の損失が発生する可能性もあります。',
  zucms: '分離ポジションモード',
  zucjs: '分離ポジションモードでは、各注文が独立して処理され、各ポジションのオープン価格に基づいて利益と損失が独立して計算されます。単一の注文の元本（または証拠金）が最大ストップロスポイントに達すると、強制的に清算されます。最大ストップロスポイントまで利益を上げると、自動的に清算されます。分離ポジションモードでは、ポジションまたは計画中の注文がある場合、分離モードでのオープンはできません。',
  gdgn: 'コピー取引機能',
  gdjs: 'コピー取引機能を開始すると、コピー取引トレーダーのすべてのポジション取得と清算の行動が同期して実行されます。口座の残高が不足するか保有ポジションの上限を超える場合は実行できません。手動でコピートレード機能をキャンセルしない限り、コピートレード機能は継続します。',
  bfpc: '一部清算',
  bfjs: '一定数量のロングポジションまたはショートポジションを保有している場合、市場の変動と損益の状況に応じて、自由に清算する金額を選択できます。同時に、清算後の変動利益が変わらないように、清算金額と証拠金総額の割合に基づいてポジションの損益金額が計算されます。',
  fxkc: '逆ポジションを取得',
  fxjs: 'システムは最適な市場価格で、現在選択されている保有ポジションを自動的に清算し、逆方向の同等数量のポジションを最適な市場価格で取得します。これにより、逆転市場を逃すことなく、または逆転市場が到来する前に適切なポジション取得を行うことができます。',
  zjbzj: '証拠金を追加',
  zjbzjjs: '一定数量のロングポジションまたはショートポジションを保有している場合、現在の保有ポジションパラメーターの前提条件下で証拠金を追加することができます。追加保証金後、ポジション係数は、オープンと追加保証金のポジションパラメーターに基づいて分配される分散ウェイトフォーミュラに従って計算されます。',

}

const risk = {
  fxbzj: 'リスク証拠金',
  fxbz: 'すべての取引に万全の資金リスクコントロール保護を提供'
}
const license = {
  license: 'ビーキングがMSB金融ライセンスを取得',
  hgyy: '合法的な運用、グローバルな展開',
  login: 'ログイン',
  download: 'ビーキングをダウンロード',
  support: 'サポート',
  jsjy: '随時取引、高速約定',
  ljxz: 'BiKing Appを今すぐダウンロード'

}

const footer = {
  yhyh: 'ユーザーフレンドリーな',
  jypt: '先物取引プラットフォーム',
  yhzc: 'ユーザーサポート',
  flsm: '料金説明',
  ggzx: 'アナウンスメントセンター',
  yhxz: 'ユーザーガイドライン',
  tksm: '利用規約',
  fxzs: 'リスク注意事項',
  xylb: '規約一覧',
  gywm: '私たちについて',
  gy: 'について',
  lxwm: 'お問い合わせ',
  appxz: 'アプリのダウンロード',
  callus: 'BIKING創世記を購読する',
  zwzxxx: '最新のニュース、洞察、価格変動を把握する',
  zc: '登録',
  email: 'メールアドレス',
  callingus: 'お問い合わせ',
  bqsy: 'すべての権利を所有',
  tips: '注意：投資にはリスクが伴います。市場参入は注意が必要です'

}

const card = {
  title: 'なぜ私たちは最もフレンドリーな契約プラットフォームなのか',
  text: 'BiKingで資産を創出、増やす、保管するのをお手伝いします',
  djxn: '手数料返金',
  jsqd: '手数料の100%がリアルタイムで返金され、取引コストを大幅に削減し、利益を得るのチャンスを高めます',
  zcbz: '高速入出金',
  cssbz: '高速な入出金で、取引中にカクつきのないスムーズな入出金を実現し、ユーザーの資金の安全性を保証します。また、取引の機会も逃しません',
  gld: '使いやすく便利',
  zxhd: '登録と取引開始はたったの10秒で完了し、独自の安全リスク管理システムでユーザーのプライバシーを保護します。登録手続きも簡単です',
  qthfw: '24時間体制のサポート',
  kffw: '快適でスムーズなインタラクティブな取引体験を提供し、金本位の保証金メカニズムで24時間体制のカスタマーサポートを提供し、取引に関する問題にリアルタイムで対応します',
  bjyy: '使いやすく便利',
  fxkk: 'さまざまな注文システムと取引ツールを提供し、リスクをコントロールできるようにしています',
  axjy: 'いつでもどこでも・安心して取引',
  bkms: 'BiKingプラットフォームは、ウェブ版、モバイルアプリ、API、FIX接続を提供しています'

}

const news = {
  title: 'ニュース＆視野',
  text: '世界トップクラスの仮想通貨取引所のニュースと特徴を知る',
  sy: '視野',
  ltitle: 'ビットコインは新興市場の特有課題の解決に挑む',
  ldesc: 'この記事は元々Cointelegraphで読まれました。新興市場の発展に焦点を当てたブロックチェーン経済イスタンブールサミット（Blockchain Economy Istanbul Summit）が開催される中、ビットコインの採用は依然として個別の需要による影響を受けているのだろうか？...',
  more: '詳しく知る',
  xwfbs1: 'プレスリリース',
  rdesc1: 'デジタル資産取引所BiKng、ブロックチェーン経済イスタンブールサミット2022をスポンサード',
  xwfbs2: 'プレスリリース',
  rdesc2: 'デジタル資産取引所BiKng、ブロックチェーン経済イスタンブールサミット 2022をスポンサード',

}

const info = {
  hzhb: '自動取引プラットフォームパートナー',
  qsjy: 'BiKingで簡単に取引するための取引ロボットを使用する',
  quadency: 'QUADENCY',
  clpt: '専門の自動取引戦略プラットフォーム',
  stacked: 'Stacked',
  glcf: 'ユーザーはStackedを使用して仮想通貨指数に投資し、自動取引と資産管理を行うことができます'

}
const menu = {
  creditCardOrder: '支払い命令',
  ptmb: 'C2C',
  kjmb: 'クイック購入',
  xykmb: 'クレジットカードで購入',
  order: '注文',
  userOrder: 'ユーザーの注文',
  merchantOrder: '事業者の注文',
  quickOrder: 'クイック注文',
    merchant:'事業者',
    asMerchant:'事業者になる',
  advertisingManage: '広告管理',
  financialStatements: '財務報告書',
  messageCenter: 'メッセージセンター',
  more: 'その他',
  paymentSettings: '支払い設定',
  publish: '広告を投稿',
  overview: '概要',
  aqzx: 'セキュリティセンター',
  phsz: 'お好みを設定',
  hykhj: 'コントラクトカーニバルシーズン、トレーディングの新時代',
  xszn: '初心者ガイド',
  bwyjy: 'コインキング研究所',
  bwsq: 'コインキング コミュニティ',
  yhxz: 'ユーザー情報',
  bwysp: 'コインキングのデリバティブ',
  jyxz: 'OTC取引指示'

}
const otc = {
    Realtimequotes:'リアルタイムの見積りは参考価格です。サードパーティのサービスプロバイダーのウェブサイトの価格をご参照ください。',
  Realtimequotes1:'取引限度額',
  Realtimequotes2:'参考価格  （{price}）',
  Realtimequotes3:'購入',
  Realtimequotes5:'購入金額を入力してください',
  Realtimequotes6:'上限',
  Realtimequotes7:'上限を超えています',
  Realtimequotes8:'数量',
  Realtimequotes9:'手数料',
  Realtimequotes10:'支払い方法',
  Realtimequotes11:'配送時間',
  Realtimequotes12:'支払い完了後10～20分',
  Realtimequotes13:'購入を確定',
  Realtimequotes14:'購入手順',
  Realtimequotes15:'購入するデジタル通貨、支払う法定通貨、サービスプロバイダーを選択してください。',
  Realtimequotes16:'購入金額を入力し、サードパーティのサービスプロバイダーのウェブサイトで情報を入力して、支払いを完了してください。',
  Realtimequotes17:'購入したデジタル通貨は、BiKingアセットのチャージ履歴と、サービスプロバイダーのウェブサイトの注文詳細で確認できます。',
  Realtimequotes18:'ご購入手続きは{XXXXX}へリダイレクトされます。',
  Realtimequotes24:'ご注意',
  Realtimequotes19:'{XXXXX}は、独立運営の第三者機関による法定通貨および暗号通貨取引プラットフォームです。関連するすべてのサービスは{XXXXX}によって提供されています。',
  Realtimequotes20:'参考価格にはプラットフォーム手数料が含まれています。実際の取引価格は{XXXXX}の公式ウェブサイトに掲載されている価格に基づきます。;',
  Realtimequotes21:'BiKingは、本サービスのご利用に起因するいかなる損失または損害についても責任を負いません。',
  Realtimequotes22:'了解しました。今すぐお進みください。',
    Realtimequotes23:'購入金額',
  Realtimequotes25:'サードパーティ取引',
      Realtimequotes26:'まずメールアドレスを入力してください。',
        Realtimequotes27:'今すぐ完了',
         Realtimequotes28:'第三者販売者名',
  meBuy: '購入したい',
  服务商: 'サービスプロバイダー',
    bjgq:'この見積もりは期限切れです。再度取得してください',
    gxbj:'見積もりを更新',
  zxkdh: '最小交換可能 {min} {symbol}',
  zdkdh: '最大交換可能 {max} {symbol}',
  Available: '利用可能残高',
  Unknown: '不明',
  qxgz: 'キャンセル規則：1日に買い手が200回以上キャンセルした場合、その日の購入機能が制限されます。',
  xncs: '貴方に売る',
  qxzzffs: '支払い方法を選択してください',
  qdqx: 'キャンセルを確認',
  wzxx: 'もう一度考えます',
  msk: '購入者の支払い方法',
  zhmc: 'アカウント名',
  zhxq: 'アカウントの詳細',
  xzhb: '通貨を選択',

  buyer: '買い手',
  seller: '売り手',
  goSet: '追加へ移動',
  addPayWayTitle: '受け取り方法を追加',
  addPayWay: '少なくとも1つの受け取り方法を追加またはアクティブにする必要があります。その後に{type}暗号通貨',
  supportPayWay: '{type}の受け取り方法を追加して有効化してください。',
  top: 'トップに留める',
  marginTips: '保証金として{baseMarginPaid} USDTがすでに入金されています。残り{needMargin} USDT以上を入金してください。',
  eyqx: '1日に3回以上申し立てをキャンセルすると、申し立ての制限がかかります。また、悪意のあるキャンセルの場合、口座が凍結されることがあります。操作に注意してください。',
  qdbzgm: '購入をキャンセルしますか？',
  qxbtk: '注文をキャンセルすると、返金されません。支払い済みの場合、注文をキャンセルしないでください。',
  yzjbzj: '一般事業者が保証金を追加しました。',
  xbjjcbzj: '基本保証金を追加する必要があります。',
  jg: '価格',
  zxjgxd: '現在の最新価格で注文する',
  je: '金額',

  ccxe: '限度額を超えています',
  yebz: '残高不足です',
  qxsm: '先に本人確認を行ってください',

  dfb: 'ロック解除待ち',
  jywc: '取引完了',
  buy: '購入',
  sell: '売却',
  coin: 'コイン',
  allCoin: '全てのコイン',
  frenchCurrency: '法定通貨',
  payWay: '支払い方法',
  all: '全て',
  bankCard: '銀行カード',
  zfb: 'Alipay',
  wx: 'WeChat',
  search: '検索',
  merchant: '事業者（30日取引完了/30日完了率）',
  turnover: '取引量',
  completionRate: '完了率',
  quotaOrNumber: '数量/限度額',
  number: '数量',
  quota: '限度額',
  price: '単価',
  paymentMethod: '受け取り方法',
  trade: '取引',
  handlingFee: '手数料 0',
  buyUsdt: 'USDTを購入',
  sellBtc: 'USDTを売却',
  theRemainingAmount: '残り数量',
  userRealName: 'ユーザーの実名',
  businessMessage: '事業者メッセージ',
  wantPay: '支払いする',
  wantSell: '売却する',
  receive: '受け取る',
  password: 'パスワード',
  pleaseEnterPassword: 'パスワードを入力してください',
  cancel: 'キャンセル',
  buyUSDT: 'USDTを購入',
  sellUSDT: 'USDTを売却',
Paymentchannel :'支払いチャネル (サービスプロバイダーの為替レートを参照してください。)',
  lumpSum: '合計金額',
  agree: 'ビーキングでのC2C取引に同意する場合、以下を承諾するものとします。',
  mzsm: 'ビーキングC2C取引免責事項',
  quit: '終了',
  confirm: '確認',
  orderDetail: '注文の詳細',
  limitExceeded: '限度額を超えています',
  quantityRemaining: '残り数量が不足しています',

  cryptoTitle: 'わずか数ステップで簡単にUSDTを購入',
  cryptoSubTitle: '世界でトップクラスの安全なデジタル資産先物取引プラットフォーム',
  availableBalance: '利用可能残高',
  sellAll: '全て売却',
  fundsTransfer: '資金振替',
  threeStep: 'コインの購入は3ステップのみ',
  advantage: 'ビーキングで暗号通貨の売買を選ぶ理由',
  commonQuestion: 'よくある質問',
  otc_title: 'C2C 手数料 0 を使用して暗号通貨を売買',
  otc_title1: 'BiKing では手数料ゼロの取引を安全かつ簡単に実行できます。 銀行振込、クレジットカード、その他の支払い方法を通じてUSDTを即座に取引できます',
  commonQuestion1: '暗号通貨のC2C取引とは何ですか？',
  commonQuestion2: 'C2C取引のコストはどれくらいですか？',
  commonQuestion3: 'BiKing C2Cの商人とは何ですか？',
  commonQuestion4: 'BiKing C2Cの商人は利益を上げることができますか？',
  commonQuestion5: 'C2C詐欺を防ぐ方法は？',
  commonQuestion1_desc: 'C2Cは、ユーザーが中央取引所のような仲介者なしに直接仮想通貨を交換できるピアツーピアの暗号通貨取引を指します。',
  commonQuestion2_desc: 'C2C取引のコストは、プラットフォーム、特定の暗号通貨、および取引時のネットワーク混雑によって大きく異なる可能性があります。ただし、BiKing C2Cは仮想通貨取引に対して手数料を一切いただかず、仲介者は必要ありません。',
  commonQuestion3_desc: 'BiKing C2Cの商人は認証されたユーザーであり、プラットフォーム上で取引広告を投稿し、他のユーザーと取引することができます。',
  commonQuestion4_desc: 'BiKing C2Cの商人の収益性は、取引戦略、取引頻度、売買の価格差、および総合的な市場状況など、さまざまな要因に依存します。',
  commonQuestion5_desc: 'C2C詐欺を防ぐためには、相手の身元を確認し、安全なプラットフォームを使用し、個人情報や財務データの共有を制限し、追跡可能な支払い手段を使用することが勧められます',
  register: '登録',
  registerByPhone: 'メールアドレスまたは携帯電話番号で登録',
  authentication: '本人認証',
  authenticationId: 'ID証明書を使用して本人認証を完了します',
  buyCoins: 'コインを購入',
  buyCoinsByCard: 'クレジットカード/デビットカードまたは銀行振込でコインを購入',
  fast: '迅速で便利',
  easyUse: 'コインの購入手順は簡単です',
  fastPayment: '数分で購入完了',
  multiplePayment: '多様な支払い方法',
  platformSupports: '多くの支払い方法を提供',
  flexibleConvenient: 'ユーザーにより多くの柔軟性と便利性のあるサービスを提供します。',
  safeReliable: '安全で信頼性があります',
  measure: '何重ものセキュリティ技術と対策を採用',
  informationSecurity: '資金の安全とユーザー情報の安全を確保します。',
  questionTitle1: '1.ビーキング取引所とは何ですか？',
  questionSubTitle1: 'ビーキング取引所は、シンガポールの主要なデジタル資産取引プラットフォームで、米国およびカナダのMSBダブルライセンスを持ち、さまざまなデジタル資産の取引、保管、管理などのサービスを提供しています。',
  questionTitle2: '2.ビーキング取引所はどのような商品を提供していますか？',
  questionSubTitle2: 'ビーキング交易所は以下の商品を提供しています：無期限先物 - ディープレベル、瞬時マッチング；現物取引 - 手数料0、高速約定；コピー取引コミュニティ - 経験豊富なトレーダー、安定した戦略トレード；ボーナス取引 - 特有のモデル、さまざまな特典；Webウォレット - 分散型のワンストップサービス。',
  questionTitle3: '3.ビーキング取引所の登録方法は？',
  questionSubTitle3: 'ビーキング取引所の公式ウェブサイトまたはアプリを使用して登録できます。登録をクリックし、登録プロセスを完了すると、ビーキング取引所を使用してデジタル資産の取引を始めることができます。',
  questionTitle4: '4.ビーキング取引所を通じてどのようにデジタル資産を購入できますか？',
  questionSubTitle4: 'ビーキング取引所のクイック購入機能は、さまざまな支払い方法と法定通貨に対応しており、世界中のユーザーが地元通貨でデジタル資産を購入できるようになっています。',
  questionTitle5: '5.どのようにデジタル資産取引を行うのですか？',
  questionSubTitle5: 'ビーキング取引所で取引したいデジタル資産を選択し、取引ページに入り、購入または売却を選択し、取引数量と価格を入力して取引を確定します。また、ビットコイン、イーサリアム、ライトコイン、リップルなどの多くのデジタル資産取引を対応しております。',
  questionTitle6: '6.ビーキング取引所はユーザーの資産をどのように保護していますか？',
  questionSubTitle6: 'ビーキング取引所は、ユーザー情報と資産のセキュリティを保護するために多層の暗号化技術と対策を採用し、またホットウォレットとコールドウォレットを分離して使用して資産の安全性を確保しています。',

  orderType: '注文のタイプ',
  orderStatus: '注文のステータス',
  to: '〜',
  startTime: '開始日',
  endTime: '終了日',
  orderNo: '注文番号',
  status: 'ステータス',
  totalPrice: '合計金額',
  numberOrFee: '取引数量/手数料',
  tradingPartners: '取引相手',
  time: '時間',
  operate: '操作',
  details: '詳細',
  noPay: '未払い',
  payed: '支払済み',
  finish: '完了',
  canceled: 'キャンセル済み',
  complaint: '申し立て中',
  legalCurrency: '法定通貨金額',
  virtualCurrency: 'デジタル通貨',
  virtualCurrencyAddress: '支払い先住所',
  paymenttype: '支払いタイプ',
  creatTime: '作成日時',
  success: '成功',
  pending: '処理中',
  awaiting: '確認待ち',
  declined: '失敗',

  mjskfs: '売り手の受け取り方法',
  mjfkfs: '買い手の支払い方法',
  toPay: '支払いへ進む',
  ddzdqx: '{payTime} までに支払い方法を選択しない場合、注文は自動的にキャンセルされます。',
  paying: '相手が支払っています...',
  fkckh: '支払い参考番号:',
  dfwfkqx: '{payTime} までに相手が支払わない場合、注文は自動的にキャンセルされます。',
  ddqxwfck: '注文がキャンセルされました。支払い情報は表示できません。',
  ddqxckh: '注文がキャンセルされました。支払い参考番号:',
  ssz: '申し立て中です。お待ちください。 支払い参考番号:',
  qxss: '申し立てをキャンセル',
  xzfkfs: '選択した支払い方法',
  ddywc: '注文が完了しました',
  ss: '申し立て',
  wcfqss: '* 注文が完了してから1分後に申し立てを開始できます',
  bnfqss: '* 注文が完了してから{time}時間後に申し立てを開始できなくなります',
  zxkf: '* OTC取引を行った後、T+1日後に出金可能です。不明な点がある場合は、カスタマーサポートにお問い合わせください。',
  sjyjn: '出品者は既に{deposit} {depositName}の保証金を支払いました',
  wen1: '1.支払いはいつ受け取れますか？',
  da1: '相手が支払いを完了すると、通知が送信されます。',
  wen2: '2.買い手が注文後に支払いを行わない場合、どのように対処すればよいですか？',
  da2: '売り手は注文をキャンセルできませんが、待機時間が長い場合は申し立てを開始できます。カスタマーサポートが解決策を提供します。',
  wen3: '3.時間内に資産をロック解除しないとどのような影響がありますか？',
  da3: '支払いを受けた後、受け取りを確認しない場合、買い手が申し立てを提起する可能性があり、プラットフォーム上での信頼性に影響を及ぼす可能性があります。また、処理されるまで資産がプラットフォームウォレットに凍結されます。',
  wen4: '4.受け取り時の注意事項',
  da4: '1) 本当に支払いを受け取ったことを繰り返し確認してください。ロック解除を急かす理由には信用せず、支払いを確認した後に「受け取りを確認する」をクリックして、デジタル資産の損失を防ぎます！<br/>2) 買い手の送金銀行口座がプラットフォームアカウントの実名と異なる場合、受け取りのリスクに注意し、疑念がある場合はすぐに申し立てしてください。',
  qzgdsjnzf: '{payTime} までに{associatedAdMerchantNickname} に {totalAmounts} {fiatCurrency}を支払ってください。支払い参考番号:',
  nxdfgm: '{associatedAdMerchantNickname}（{realName}）から{amount_s} {coinsName}を購入します。',
  dfxngm: '{userNickName}（{realName}）から{amount_s} {coinsName}を購入します。',
  nxdfcs: '{associatedAdMerchantNickname}（{realName}）に{amount_s} {coinsName}を売却します。',
  dfxncs: '{userNickName}（${realName}）に{amount_s} {coinsName}を売却します。',
  payed: '支払済み',
  dddffx: '相手がロック解除するのを待っています...',
  njhdq: '{quantity}{coinsName}が受け取れます。',
  qxdd: '注文をキャンセル',
  kfqss: '支払い後、{complaintPayed}分経過すると、相手がまだロック解除しない場合、申し立てを開始できます。',
  yfkfkckh: '相手が支払い済みです。支払い参考番号:',
  qjkqrsk: '受け取りを確認してください。',
  ddnsk: '受け取りを待っています。',
  zfje: '支払い金額',
  skzh: '受け取りアカウント:',
  fkzhxm: '支払い口座名義:',
  qdskh: '* 支払いを受け取ったことを確認してから、確認を行ってください。',
  fbl: 'ロック解除',
  dfyqrfk: '* 相手が支払いを確認済みであっても、{complaintPayed}分以上経過し、実際に受け取ったことが確認できない場合に申し立てを開始できます。',
  jkcssk: '* 相手が支払いを確認して24時間以上経過した場合、申し立てを開始できません。速やかに受け取りを確認してください。',
  qrfb: 'ロック解除を確認',
  qwbqr: '現在の注文に対する支払い受け取り、金額が正しいことを確認した後にロック解除してください。',
  wyqrskzq: '支払いを受け取り、金額が正しいことを確認しました。',
  tjssyy: '申し立ての理由を提出してください。',
  srssyy: '申し立ての理由を入力してください。',
  sctpxt: '画像をアップロード（オプション）',
  upload: 'アップロード',
  zdscsz: '* 最大3枚の画像をアップロードできます。jpeg、jpg、png形式に対応しています。サイズは3Mb未満である必要があります。',
  sstj: '提出する',
  qrfk: '支払の確認',
  fkje: '支払金額',
  sdzz: '*プラットフォームでは自動引き落としに対応していません。上記の口座に自分の口座から送金してください。送金が完了したら、必ず支払いをクリックしてください。送金後に支払いボタンをクリックしなかった場合、発生した損失は自己負担となります。',
  bzts: '*送金時にBTC、USDT、BiKingなどの情報を備考欄に記入しないでください。そうしないと、売り手が拒否する場合があります。',
  wfk: '未払い',
  w: '私',
  srxxfs: '情報を入力し、Enterキーを押して送信',
  "dan": '単一',
  bnch: '同じ種類の支払方法を追加できません',
  sd:'スワップ',
  from:'支払',
  to:'得る',
  rate:'交換比率',
  fees:'手数料',
  slippage:'滑り',
  standards:'手数料の請求基準',
  transactionamount:'取引金額の {num}',

  confirm:'交換を確認し',
  records:'すべてのフラッシュ引き換え記録',
  tocurrency:'通貨を消費し',
  consumption:'消費量',
  Getcurrency:'通貨を取得する',
  GetQuantity:'数量を取得し',
  ExchangeStatus:'交換状況',
  Exchangetime:'交換時間',
  Youwillconsume:'消費します',
  YouwillGET:'得られるのは',
  Updatequote:'見積を更新する',
  Failed:'失敗',
  Consumption:'消費チャネル',
  Completed:'完了しました',
  successful:'償還が成功しました',
  chaeckrecords:'すべてのフラッシュ引き換え記録を表示》',
  Converted:'{aaa} から {bbb} への変換に成功しました',
  recommend:'推薦する',
  wcsj: "完了時間"
};
const otcMerchant = {
  bzj: '保証金',
  mmggs: '売買広告数',
  bx: '無制限',
  ggzed: '広告総額',
  kzjgged: '追加可能な広告額',
  zjbzjbs: '追加保証金倍率',
  tbzss: '10件同期表示',
  tjsjsqb: '事業者申請フォームを提出する',
  wcgjkycrz: '高度なKYC認証を完了する',
  ynlx: 'フォームの審査後、OTCの専門家が速やかに連絡いたします',

  zbzl: '準備資料',
  kssh: '迅速な審査',

  h1: 'スマートトレーディング',
  h2: 'C2Cトレーディングエキスパートになる',
  h3: '認証事業者になる予定',
  sjqy: '事業者の権益',
  c2cjy: 'C2Cトレーディングに<span>無料手数料</span>を提供するだけでなく、事業者にはさらに豊富な権益を提供します',
  fbq: 'あなたの法定通貨エリア',
  ptsj: '一般事業者',
  xsqy: '認証事業者になって、より多くの権益を享受する',
  wtd: '申請が成功すれば、注文を出すことができます',
  xjn: '保証金{deposit}を支払う必要があります',
  ljsq: '今すぐ申請',
  cwptsj: 'あなたは一般事業者になりました',
  cwrzsj: 'あなたは認定事業者になりました',
  rzsj: '認証事業者',
  xrd: '取引市場の最高の信頼度を享受する',
  nbyq: 'Biking内部招待のみ',
  rzbs: 'より信頼される事業者の認証マークを取得',
  pmq: '優先ランキングの権利を取得する',
  kffw: 'マンツーマンのカスタマーサービスを受けられる',
  sjxy: 'OTC認証事業者規約',
  xsjc: '初心者ガイド',
  jygz: '取引規則',
  close: '閉じる',
  submited: '送信済み',
  submitSuccess: '送信成功',

  sqsj: '事業者申請',
  fwxy: 'bikingビーキング事業者サービス契約',
  xyb: 'ビーキングネットは、ユーザーがデジタル資産取引を行い、関連サービスを提供するためのプラットフォームです。本規約の表現の都合上、本文中で「私たち」といった呼び方で、弊社およびこのウェブサイトを指します。このウェブサイトに登録してログインする自然人またはその他の主体はすべてこのウェブサイトのユーザーであり、本規約の表現の都合上、「あなた」といった呼び方で使用されます。本規約の表現の都合上、私たちとあなたは「当事者」として合意し、私たちまたはあなたは「一方」として個別に呼ばれます。',
  ptsm: 'プラットフォーム声明：',
  p1: '1. 本ウェブサイトは、デジタルアセット取引情報を提供し、デジタルアセットの取引に関する協議、交渉、取引の場を提供するものであり、デジタルアセットの売買取引そのものには参加しません。したがって、取引の当事者は、関連するデジタルアセットと/または情報の真偽、合法性、有効性を慎重に判断し、自己責任でこれに対する責任と損失を負う必要があります。',
  p2: '2. 本ウェブサイトの意見、メッセージ、ディスカッション、分析、価格、提案およびその他の情報は、一般的な市場コメントであり、投資への助言にはなりません。私たちは、この情報によって直接または間接に生じる損失（利益損失を含むがこれに限られない）について一切の責任を負いません。',
  p3: '3. 本ウェブサイトの内容は随時変更される可能性があり、事前の通知は行いません。ウェブサイトの情報の正確性を合理的な措置で保証していますが、その正確性は保証できません。また、ウェブサイト上での情報、またはインターネットの接続、および情報の伝達および受信の遅れ、または失敗によって直接または間接に生じる損失についても一切の責任を負いません。',
  p4: '4. インターネット形式の取引システムを使用することにもリスクが伴います。ソフトウェア、ハードウェア、インターネット接続の障害などが含まれます。私たちはインターネットの信頼性と可用性を制御できないため、失真、遅延、リンクの失敗に関して一切の責任を負いません。',
  p5: '5. 本ウェブサイトをマネーロンダリング、密輸、商業賄賂などの非合法な取引活動や違法行為に使用することは禁止されています。非法な取引活動や違法行為の疑いがある場合、本ウェブサイトは口座の凍結、関連する権限機関への通知などのさまざまな手段を取る権利を留保します。これによって生じるすべての責任を負いません。関連する人々に対して責任を追及する権利を留保します。',
  p6: '6. 本ウェブサイトを市場の悪意のある操作、不正取引などの非倫理的な取引活動に使用することは禁止されています。このような事象が発生した場合、本ウェブサイトは市場価格を悪意に操作し、取引システムに悪影響を与える不道徳な行動に対して警告、取引制限、アカウントの閉鎖などの予防的な保護措置を取ります。これによって生じるすべての責任を負いません。関連する人々に対して責任を追及する権利を留保します。',
  p7: 'ビーキングネットサービス規約に同意する際には、プラットフォームの声明の内容にも同意したことになります。この契約は、あなたとビーキングネットの運営者との間で共同で締結されるものであり、完全な契約効力を持っています。',
  zcbzj: '第1条：資産保証金',
  p8: '1. 字御者がプラットフォームのKYCおよびAML審査を通過した後、当プラットフォームは事業者にプラットフォームの口座に一定の保証金を預けるように要求します。これにより、事業者の取引の安全性と円滑性を保証します。',
  p9: '2. 保証金の具体的な金額は、事業者のプラットフォームの法定通貨の資産に表示され、取引プロセス中にユーザーにも表示されます。',
  p10: '3. 次のような状況が発生した場合、プラットフォームは事業者の保証金を差し押さえなどの方法で処理する権利があり、保証金は1ヶ月以上差し押さえられ、プラットフォームおよびユーザーに損害を与えると確認された場合は、その後、保証金が割り当てられます。',
  p11: '1) 取引中に事業者がトラブルを起こし、事業者に過失があることが判明し、対応しなかった場合。',
  p12: '2) 事業者がプラットフォームで本人確認済みではないアカウントと取引を行った場合。',
  p13: '3) 事業者がプラットフォームを不正な行為に利用した場合。',
  p14: '4) 事業者が本規約またはプラットフォーム上のその他の法的書類、規則を違反した場合。',
  p15: '5) 事業者がユーザーを他のプラットフォームへ誘導した場合。',
  p16: '6) 事業者がユーザーを偽って登録させ、プラットフォームの新しいユーザーのプロモーション報酬を騙し取る場合。',
  p17: '7) 事業者がプラットフォームのパートナーのユーザーを他のプラットフォームに誘導する場合。',
  cxzg: '第2条：事業者資格の取り消し',
  p18: '次の状況が発生した場合、プラットフォームは事業者の資格を単方で取り消す権利があります。',
  p19: '1. 取引中に何度もプラットフォームのユーザーからクレームを受けた場合。',
  p20: '2. 提出された申請書類に虚偽の情報が含まれた場合。',
  p21: '3. 取引中に詐欺などの不誠実な行為が発生した場合。',
  p22: '4. プラットフォームのカスタマーサポートが注文の処理に協力しないか、意図的に処理を遅らせる場合。',
  p23: '5. プラットフォームのルールを悪用して利益を得た場合。',
  p24: '6. 法律法令、本規約、またはプラットフォームの法的文書または取引規則に違反した場合。',
  p25: '7. プラットフォームが公序良俗、公平な取引に合致しないと認定する行為が発生した場合。',
  p26: '8. その他、法律法令に違反する行為があった場合。',
  zlbh: '第3条：事業者情報の保護',
  p27: '1. 事業者情報の管理：事業者が事業者になるために提出した認証情報（以前の本人確認情報を含む）は、取り消しできない形で本プラットフォームに保管されることに同意します。本プラットフォームは、法的または契約上の義務がある場合を除き、認証情報を公開、編集、開示することはなく、非公開のコンテンツをビジネス目的で使用することはありません。ただし、以下の場合を除きます：あなたがプラットフォームが関連情報の開示を認めた場合;',
  p28: '2. 国家司法機関および行政機関への提供;',
  p29: '3. 本プラットフォームが関連企業に提供;',
  p30: '4. 第三者と本プラットフォームが共同にユーザーにサービスを提供する場合、その第三者がユーザーに提供するサービスに必要な関連情報;',
  p31: '5. 第三者があなたとの民事トラブルを解決するために必要な場合、本プラットフォームは第三者に対してあなたの身元情報を提供する権利があります。',
  sjcn: '第4条：事業者の約束',
  p32: '1. 本規約のすべての条項に同意することは、認証申請を行うための前提条件です。',
  p33: '2. あなたは、認証申請の目的は違法行為、または本規約で禁止されている行為を行うためではないとことを保証します。',
  p34: '3. 他のウェブ サイトや他のウェブ サイトのサービス、または本ウェブ サイトに損害を与えたり、通信障害させたり、過負荷をかけたり、他のサイトや、サイトのサービスを妨害したり、または他の事業者の申請を妨害する目的で申請サービスを使ってはいけません。',
  p35: '4. あなたは、本プラットフォームが許可しない方法でいかなる資料や情報を取得することも試みないでください。',
  p36: '5. あなたは、本プラットフォームを使用して取引を行う際、法律法令を遵守し、プラットフォームのデジタルアセット取引の秩序を破壊する目的ではないことを確認し、約束します。',
  p37: '6. 事業者は、プラットフォームがデジタルアセット取引に関するすべての情報開示要件に従うことを約束し、プラットフォームの要件に従って文書、資料、情報を提供します。商人がプラットフォームが要求する文書、資料、情報の提供を拒否した場合、甲側は資格を取消する決定をする権利があります。',
  ptmz: '第5条：プラットフォームの免責事項',
  bcfx: '次の場合、プラットフォームはいかなる責任も負いません：',
  p38: '1. あなたが他の人にアカウントパスワードを知らせたり、パスワードを適切に保管しなかったり、アカウントを他の人と共有したり、その他のプラットフォームの過失以外の理由によって個人情報が漏洩した場合。',
  p39: '2. ハッカーの攻撃、コンピュータウイルスの感染や侵入、電信部門の技術調整による影響、政府の規制による一時的な停止、第三者の理由（国際的な主幹回線や国際的な出口電気通信プロバイダーの一方が障害を起こしたり、火災、水害、雷撃、地震、洪水、台風、竜巻、火山噴火、流行病、伝染病流行、ストライキ、運輸機関の障害など）によってデジタルアセット取引プラットフォームがサービスを一時的に停止する場合。',
  p40: '3. 本サイトのリンク他のウェブサイト（オンラインバンキングなど）への接続により、銀行口座情報が漏洩し、それによって生じる法的なトラブルおよび結果。',
  p41: '4. ユーザーが本サイトに誤った、不完全な、虚偽の情報を提供することにより認証に通らなかった場合、あるいは他の不利益を受ける場合でも、本サイトは一切責任を負いません。',
  p42: '5. 本プラットフォームの過失が原因ではない、資産が詐欺行為に遭われた場合',
  ptts: '第6条：その他',
  p43: '1. 身元情報の確認のため、本ウェブサイトには第三者ウェブサイトへのリンク（オンラインバンキングなど）が含まれる可能性があります（以下「リンクウェブサイト」といいます）。リンクウェブサイトは本ウェブサイトが制御しておらず、リンクウェブサイト内のリンクなども含む、リンクウェブサイトの変更または更新すべてについて、本ウェブサイトは一切責任を負いません。リンクウェブサイトからのネットワーク通信またはその他の形式の送信についても本ウェブサイトは責任を負いません。',
  p44: '2. 本プラットフォームは、あなたが当ウェブサイトを通じてデジタルアセットの取引活動（デジタルアセット取引などのサービスを含むがこれに限らない）を行うためのオンライン取引プラットフォームサービスを提供するものであり、本ウェブサイトは買い手やセラーとしてデジタルアセットの売買行為そのものには参加せず、国家の法定通貨の入金および出金に関するサービスは提供しません。',
  p45: '3. 当ウェブサイトにログインし、当ウェブサイトの任意のサービスを使用し、または他の当ウェブサイトで許可された方法で実際に当ウェブサイトが提供するサービスを使用すると、これはあなたが本規約のすべての条件を完全に理解し、同意し、受け入れることを意味します。当ウェブサイトが本規約を随時変更する場合でも同様です。変更された規約は、規約のホームページに変更された日付が表示されるとすぐに効力を生じます。',
  p46: '4. あなたが「同意」または類似の意味を持つボタンをクリックするか、他の当ウェブサイトで許可された方法で実際に当ウェブサイトが提供するサービスを使用する際に、これはあなたが本規約の全ての条項に完全に理解し、同意し、受け入れることを意味します。あなたの手書きの署名がない場合でも、本規約はあなたへの法的拘束力への影響はありません。',
  p47: '5. 私たちは随時本契約を修正する権利を保持し、ウェブサイトのアナウンスメントによって変更内容を通知します。変更後の規約は、本規約のホームページに変更の日時を表示し、ウェブサイト上で公表された時点で自動的に効力を発揮します。別途個別の通知は行いません。',
  tyxy: '私はこの規約内容に同意します',
  nextStep: '次へ'
}
const user = {
  txxz: 'パスワード変更24時間経過後、取引ができます',
  name: 'ニックネーム',
  rzdj: '本人確認レベル',
  phone: '携帯電話',
  email: 'メール',
  zzc: '資産評価',
  hours24: '24時間',
  market: '市場の動向',
  notice: 'アナウンスメント',
  more: 'もっと見る>>',
  cb: '入金',
  tb: '出金',
  hz: '振替',
  wsm: '未認証',
  cjrz: '初級認証',
  gjrz: 'ハイレベル認証',
  qwgjrz: "上級認証へ進む",
  aqszx: 'セキュリティ設定項目が完了しました',
  xgaqszx: 'セキュリティ設定項目を変更する',
  dlmm: 'ログインパスワード',
  zjdl: 'ログインパスワードを設定すると、アカウントとパスワードで直接ログインできます',
  ghmm: 'パスワードの変更',
  sz: '設定',
  jymm: '取引パスワード',
  yzjymm: 'アカウントの資金変動時には、まず取引パスワードを確認する必要があります。',
  ghjymm: '取引パスワードを変更',
  sjyz: '携帯電話認証',
  yzdx: 'ログイン、出金、パスワード変更、セキュリティ設定時に認証メッセージを受信する',
  xgsj: '携帯電話番号の変更',
  zwbd: '未登録',
  ggyz: 'Google 認証',
  syzn: '使用ガイド',
  bd: '登録',
  yxyz: 'メールアドレス認証',
  tbqr: 'よく使うメールを登録することで、ログイン、パスワードのリセット、出金時の確認に使用できます',
  bdyx: 'メールアドレスを登録する',
  xgyx: "電子メールを変更",
  xyx: "新しいメール",
  dljl: '最新10件のログイン履歴',
  zjdljl: 'これが最新の10件のログイン履歴です',
  dlsj: '最後のログイン時間',
  ip: 'IP アドレス',
  aqsz: 'セキュリティ設定',
  yhdl: 'ユーザーログイン',
  xgbdsj: '登録された携帯電話番号の変更',
  bdsj: '携帯電話番号を登録',
  dxyzm: 'SMS 認証コード',
  second: '秒',
  fsyzm: '送信',
  xsjh: '新しい携帯電話番号',
  ggyzm: 'Google 認証コード',
  yxyzm: 'メール認証コード',
  confirm: '確定',
  edit: '編集',
  name: '氏名',
  srxm: '氏名を入力してください',
  zjlx: '確認書類の種類',
  xzzjlx: '確認書類の種類を選択してください',
  zjhm: '確認書類番号',
  srzjhm: '確認書類番号を入力してください',
  zcsr: 'パスワードを再度入力してください',
  mmbyz: 'パスワードが一致しません！',
  sfz: '本人確認書類',
  jgz: '軍人証',
  hz: 'パスポート',
  jmtxz: '台湾居住者通行証',
  gatxz: '香港・澳門居住者通行証',
  hwid: '海外 ID',
  srdx: 'SMS 認証コードを入力してください',
  sryx: 'メール認証コードを入力してください',
  srgg: 'Google 認証コードを入力してください',
  jdlmm: '旧ログインパスワード',
  xdlmm: '新しいログインパスワード',
  qrxmm: '新しいパスワードを確認',
  qrdlmm: 'ログインパスワードを確認',
  jjymm: '旧取引パスワード',
  xjymm: '新しい取引パスワード',
  qrjymm: '取引パスワードを確認',
  qwcyz: '確認を完了してください',
  smrz: 'まず本人確認を行ってください',
  sryzm: '認証コードを入力してください',
  srsjh: '携帯電話番号を入力してください',
  xgdlmm: 'ログインパスワードを変更する',
  szdlmm: 'ログインパスワードを設定する',
  xgjymm: '取引パスワードを変更する',
  szjymm: '取引パスワードを設定する',
  czmm: 'パスワードをリセットする',

  bdgg: 'Google認証システムを登録',
  lbyzq: 'Google 2 段階認証システムをダウンロードしてください',
  smewm: 'Google 2 段階認証システムで QR コードをスキャン',
  srdm: 'QR コードが読み取れない場合は、以下のコードを手動で入力してください',
  copy: 'コピー',
  copySuccess: 'コピーしました',
  sryx: 'メールアドレスを入力してください',
  srzqyx: '正しいメールアドレスを入力してください',
  srsjyzm: 'SMS認証コードを入力してください',
  sryxyzm: 'メールアドレス認証コードを入力してください',
  srggyzm: 'Google認証コードを入力してください',
  passwordTypeError: 'パスワードのフォーマットが正しくありません。パスワードは8〜32文字で、大文字と小文字、数字を含む必要があります。',
  passwordDiff: 'パスワードが一致しません',
  zcsrxmm: 'パスワードを再度入力してください',
  language: '言語',
  bdhb: '現地通貨',
  wdbph: 'ステーブルコインの優先度',
  "相关问题": "関連する質問",
  "为什要进行身份认证": "なぜ身分証明が必要ですか",
  "上传中": "アップロード中...",
  "开始上传": "アップロードを開始",
  "请手持身份证正面": "身分証の正面を手に持ってください",
  "正对摄像头": "カメラに正対してください、5秒以上保持してください",
  "摘下眼镜": "メガネ、帽子などを外してください",
  "请按视频文字提示录制视频": "画面の指示に従ってビデオを録画してください",
  "开始录制": "録画を開始",
  "第一段视频": "第1セグメントのビデオ",
  "第二段视频": "第2セグメントのビデオ",
  "录制一段视频": "ビデオのセグメントを録画",
  "点击开始录制": "録画を開始するにはクリック",
  "视频录像认证": "ビデオ録画認証",
  "身份证号": "身分証番号",
  证件验证: "本人確認書類の確認（写真/スキャン）",
  zjyz: "本人確認書類の確認",
  "请确保图片格式为": "画像の形式がjpg/jpeg/pngであることを確認してください。画像のサイズが2MB未満であることを確認してください",
  "请手持证件照": "身分証の写真と個人の署名を手に持ってください。署名には「Biking」と当日の日付を含めてください",
  "当日签名照": "身分証の写真+当日の署名",
  "上传证件签名页": "身分証の署名ページをアップロード",
  "请保证所有信息清晰": "すべての情報がクリアであることを確認してください",
  "上传证件页信息": "身分証の情報ページをアップロード",
  "请选择国家": "国を選択してください",
  "请选择区域": "地域を選択してください",
  "认证要求": "認証要件",
  "证件信息": "身分証の情報",
  "人脸识别": "顔認識",
  "立即认证": "即座に認証",
  "什么是加密货币P2P交易": "暗号通貨P2P取引とは",
  "最好的P2P加密货币交易所是什么": "最高のP2P暗号通貨取引所は何ですか",
  "P2P交易的成本有多少": "P2P取引のコストはいくらですか",
  "什么是BikingP2P上的商家": "Biking P2Pの商人とは何ですか",
  "我们正在审核您的申请": "申請を審査中です",
  "预计审核时间": "審査予定時間：72時間",
  "驳回": "却下",
  "未提交": "未提出",
  "手续费等级": "手数料レベル",
  "去认证": "認証に進む",
  "开通更多权限": "身分を証明してより多くの権限を開く",
  "在别人贪婪时要保持警惕": "他人が欲深いときは警戒し、他人が警戒しているときは欲深い",
  'kyc声明': '私は{Name}で、証件番号は：{No}です。私はBikingでの登録と取引を自発的に行い、アカウントが私自身によって使用されていることを保証します。すべての資産は合法な出所であり、すべての取引リスクを理解し、受け入れることができると約束します。抽出されたデジタル資産は違法な目的で使用されず、このプラットフォームを介して資金洗浄、ピラミッドスキーム、違法な通貨交換などの任意の違法活動に関与しないことを保証します。',
  编辑头像: "プロフィール画像の編集",
  请选择一个头像用作您个人资料的照片: "プロフィール画像として使用する画像を選択してください",
  中国: "中国",
  其他: "その他",
  questionTitle1: '1. なぜ本人確認が必要ですか？',
  questionSubTitle1: 'CoinKingは、全世界の規制に準拠した身元確認サービスを採用し、すべてのユーザーの資金安全を保障しています。したがって、情報を記入する際は、要件を満たす文書を必ず提供してください。',
  questionTitle2: '2. 本人確認を完了する利点はありますか？',
  questionSubTitle2: 'すべてのユーザーは、CoinKingのOTC機能にアクセスするために本人確認を完了する必要があります。本人確認を完了していないユーザーは、チェーン上の入金や引き出しに影響を与えません。',
  questionTitle3: '3. 本人確認を更新する方法は？',
  questionSubTitle3: '身元情報が変更され、以下の条件を満たす場合は、オンラインサポートに連絡して本人確認を更新する申請を提出できます：',
  questionTitle4: '4. KYC認証にはどれくらいの時間がかかりますか？',
  questionSubTitle4: '提出された情報は通常、5分以内に確認されます。ただし、特別な状況によっては、より長い時間が必要になる場合があります。',
  questionTitle5: '5. CoinKingの本人確認は安全ですか？',
  questionSubTitle5: 'CoinKingの本人確認は安全であり、お客様とすべての他のユーザーのために安全なプラットフォームを構築するのに役立ちます。お客様の文書も当社によって機密保持されます。',
    questionTitles:'1. 資料の有効期限が切れています。',
    questionTitles1:'2. 資料の名前が変更されています。',
    questionTitles2:'3. 資料のID番号が変更されています。',
    questionTitles3:'4. 国籍が変更されています。',
    questionTitles4:'5. 通貨を正常に使用するために資料を更新してください。',
    questionTitles5:'6. システム言語識別の名前を変更します（たとえば、国民IDからパスポートに変更します）。',
  Z1001: "システムエラー",
  Z1003: "検証中断",
  Z2002: "ネットワークエラー",
  Z2003: "クライアントデバイスの時間エラー",
  Z2006: "認証に失敗しました",
  Z5050: "顔認証成功",
  Z5051: "顔写真のアップロードに失敗しました",
  Z5052: "データエラーまたはプログラムの例外が発生しました。",
  Z5053: "ネットワークエラー。",
  Z5054: "カメラにアクセスできないか、カメラデータを取得できません。",
  Z5055: "ユーザー退出。",
  Z5056: "リトライ回数が多すぎます。",
  Z5057: "ビデオのアップロードがタイムアウトしました。",
  Z5058: "ビデオの形式が要件を満たしていません。",
  Z5059: "ビデオに有効な顔がありません。",
  Z5128: "検証が同一の人物ではありません。",
    法币充值:'法定通貨入金＆引き出し制限',
    無限额:'制限なし',
    数字货币充值:'暗号通貨入金',
    数字货币提现限额:'暗号通貨引き出し制限',
    C2C交易限额:'C2C取引制限',
  "参数不合法": 'パラメータが無効です',
  h5smrz: "実名認証",
  bhzhan: "アカウントのセキュリティを保護するためにパスワードを設定してください",
  jxsmrz: "ユーザー資金の安全性を確保するために実名認証を実行します",
  qwrz: "認証へ進む",
  dgzhzd: "1. 1つのアカウントで、1日最大5回まで送信できます。",
  rhzp: "2. お客様が提出した写真、動画、または書類の詳細情報は一切保存されず、いかなる方法でも使用されません。",
  sfzm: "身分証明",
  zjqfg: "証券発行国",
  dw: "位置情報",
  sfxx: "本人情報",
  dqdw: "現在地",
  gjdq: "国・地域"
}

const h5 = {
  chart: 'チャート',
  mmp: '売買板',
  sscj: 'リアルタイム取引',
  wt: '注文',
  lswt: '過去の注文',
  zj: '資金',
  sj: '市場価格',
  ky: '利用可能',
  zczh: '資産換算',
  dj: '凍結',
  zwsj: 'データなし',
  zx: 'お気に入り',
  buysell: '買い/売り'
}

const worldCup = {
  common: {
    cancel: 'キャンセル',
    confirm: '確認する',
    iKnow: 'なるほど',
    points: '積分',
    day: '空',
    hour: '時間',
    minute: 'ポイント',
    second: '2番',
    noData: 'データなし',
    noMatch: '試合はありません',
    businessClosed: 'サービスは終了しました',
    loadFailed: '読み込みに失敗しました。しばらくしてからもう一度お試しください',
  },
  index: {
    liveFeed: 'リアルタイムダイナミクス',
    heroTitle: 'ワールドカップに賭ける',
    heroSplit: '切り分ける',
    heroPrizePool: '賞金総額',
    heroMillionPrizePool: '100万賞金プールを山分け',
    heroSub: 'テスラやワールドカップのチケットもあなたを待っています。',
    heroJoinedPrefix: 'すでに',
    heroJoinedSuffix: '多くの人が参加しており、賞金総額は増え続けています。',
    activityTimeLabel: '活動時間:',
    refreshing: '爽やかな...',
    releaseToRefresh: '放すとすぐに更新されます',
    pullToRefresh: 'プルダウンして更新します',
    livePrizePool: 'リアルタイムの賞金プール',
    growing: 'リアルタイムで成長する',
    userPoolRatioLabel: '個々のユーザーは賞金プールを共有できます。',
    teamPoolRatioLabel: 'チームは賞金プールを共有できます。',
    poolCountdownLabel: '第{phase}段階の賞金プール分割までのカウントダウン',
    poolCountdownFinalLabel: '最終段階の賞金プール分配までのカウントダウン',
    poolActivityStartCountdownLabel: 'イベント開始まで',
    poolSplitDoneBadge: '賞金プールの分配が完了しました',
    totalAllocatedPoolLabel: '分配賞金プール合計',
    poolAllocateFirst: '第1回の分配',
    poolAllocateSecond: '第2回の分配',
    poolAllocateThird: '第3回の分配',
    poolAllocateFinal: '最終分配',
    poolTeamPrefix: 'チーム：',
    poolPersonalPrefix: '個人：',
    poolPersonalCount: '個人：{n}人',
    teamTitle: 'チームを結成して収入を倍増させましょう',
    teamSubPrefix: 'チームに参加して改善の機会を得る',
    teamSubSuffix: '所得',
    teamAgentTitle: 'エージェントチーム',
    teamAgentDesc: 'プラットフォーム エージェントはワンクリックでチームを結成でき、<span class="wc-hl"> チーム メンバー ポイントが合計チーム ポイント </span> に集約されます。同時に、チームのタスクを完了すると、<span class="wc-hl"> の追加チーム ポイント </span> を獲得できます。チーム ポイントが高いほど、賞金プールを共有する <span class="wc-hl"> の可能性が </span> 高くなります。',
    createTeamNow: '今すぐチームを結成しましょう',
    applyAgentNow: '私はエージェントではありません。今すぐお申し込みください',
    teamUserTitle: '自由チーム',
    teamUserDesc: 'エージェントになる必要はありません。無料チームに参加したり、他の無料ユーザーとチームを結成したり、__​​PH_0__ チーム ポイント</span> に参加したり、__​​PH_2__ の賞金プールを共有</span> する機会を得ることができます。',
    joinNow: '今すぐ参加',
    championTitle: '優勝予想',
    championSub: '各ユーザーは 1 回だけ予測でき、ロック後は変更できません。推測が正しければ、賞金プールを個別に共有する資格が得られます。',
    championHintPrefix: '正しい勝者を予想したユーザーは賞金プールを受け取ります',
    championHintSuffix: '彫るための資格',
    championPoolShare: '彫るための資格',
    championWin: '優勝者予想おめでとうございます',
    championLose: '申し訳ありませんが、正しく推測できませんでした',
    championWinSub: '個人賞金プールを分け合う資格を獲得',
    championNoParticipation: 'イベント終了、予想に参加していません',
    confirmPredict: '予測を確認する',
    predictCountdown: '予測カウントダウン',
    predictEnded: '予測は終了しました',
    notice1: 'ユーザー p***12 はベットを完了し、500 ポイントを獲得しました',
    notice2: 'ユーザー k***88 が Tesla を引き換えました',
    notice3: 'ユーザー a***23 はベットを完了し、1200 ポイントを獲得しました',
    notice4: 'ユーザー x***56 が友達を招待して 100 ポイントを獲得しました',
    notice5: 'ユーザー m***07 がワールドカップ チケットを 1 枚引き換えました',
    tabPredict: '賭け',
    tabTask: 'タスク',
    tabRank: 'ランキング',
    tabExchange: '交換',
    tabMine: '私の',
    tabRules: 'ルール',
  },
  toast: {
    refreshSuccess: '更新に成功しました',
    predictSuccess: '賭けは成功した',
    inviteJumping: '招待ページにジャンプします...',
    applyAgentPending: 'エージェントアプリ機能は開発中ですのでご期待ください！',
    championLocked: '優勝予想は確定です！',
    exchangeSubmitted: '引き換え申請は正常に送信され、プラットフォームのカスタマー サービスから賞品の配布についてご連絡させていただきます。',
    pointsNotEnough: 'ポイントが不足しています',
    createTeamSubmitted: 'チーム作成に成功しました',
    joinedFreeTeam: 'フリーダムチームに参加しました',
  },
  section: {
    predictTitle: '試合の賭け',
    predictSub: 'ゲームの結果を予想します。正解の場合 +{correctPoints} ポイント、不正解の場合 +{wrongPoints} ポイント',
    predictRules: '賭けの指示',
    taskTitle: 'タスクを完了してポイントを獲得',
    taskSub: '複数のタスク、複数の報酬、加速された利益の蓄積',
    exchangeTitle: 'ポイント還元モール',
    exchangeSub: '豪華賞品、先着順',
    exchangeRules: '引き換え手順',
    rankTitle: 'リアルタイムのリーダーボード',
    rankSub: '強さを競い、トップの座を狙う',
    rulesTitle: '活動ルール',
    rulesSub: '透明、オープン、公正、公正',
  },
  dialog: {
    taskTitle: 'ミッションステートメント',
    taskReward: '完了後に利用可能',
    predictConfirmTitle: '試合の賭け',
    predictConfirmHint: 'どのチームが勝つと思いますか?',
    predictPay: '支払う',
    predictPayTip: '資金口座からの引き落とし、残高が十分であることを確認してください',
    predictConfirmBtn: 'ベットを確認する',
    predictSuccessTitle: '賭けは成功した',
    predictSuccessDesc: '賭けの結果は正常に送信され、記録は「My Betting」で確認できます。',
    exchangeTitle: '商品交換',
    exchangeNeedPoints: '必要ポイント',
    exchangeBalance: 'バランス：',
    exchangeContactTitle: '少なくとも 1 つの連絡先情報を入力してください',
    exchangeTipTitle: '親切なヒント',
    exchangeTip1: '少なくとも 1 つの連絡先情報を入力してください。提出後、プラットフォームのカスタマーサービスから賞品の配布について連絡があります。',
    exchangeTip2: '長期間連絡がない場合は、カスタマーサービスまでご連絡ください。',
    exchangeConfirm: '交換の確認',
    teamJoinTitle: 'チームに参加する',
    teamCreateDesc: 'チームを結成してもよろしいですか?',
    teamJoinFreeDesc: 'フリーダム チームに参加しますか?',
    teamJoinTipTitle: '親切なヒント',
    teamJoinTipDesc: 'あなたはエージェント チームのメンバーであるため、無料チームに参加することはできません。招待者（エージェント）を招待してチームを結成し、チーム戦に参加できます。',
    applyAgentContactTitle: '重要なお知らせ',
    applyAgentContactPrefix: 'Telegram に追加してください：',
    applyAgentContactSuffix: ' のうえで代理店をお申し込みいただけます。代理店承認後、チームを作成できます。',
    applyAgentContactBtn: '了解',
  },
  rank: {
    teamRank: 'チームランキング',
    personRank: '個人的ランキング',
    yourTeamRank: 'あなたのチームのランキング',
    yourPersonRank: 'あなたの個人的なランキング',
    captain: 'チームリーダー:',
    currentPoints: '現在のポイント',
    members: 'メンバー',
    teamDetail: 'チーム詳細',
    noRankYet: 'ランキングはまだありません',
  },
  mine: {
    myPoints: '私のポイント',
    totalPoints: '合計ポイント',
    myPredict: '私の賭け',
    myExchange: '私の交換',
    myBonus: '私の賞金',
    totalBonus: '獲得した総賞金',
    bonusPhase: '分配段階：',
    bonusPhaseFirst: '第1段階',
    bonusPhaseSecond: '第2段階',
    bonusPhaseThird: '第3段階',
    bonusPhaseFinal: '最終段階',
    bonusTypeTeam: 'チーム分配',
    bonusTypePersonal: '個人分配',
    bonusPoints: '分配時のポイント：',
    bonusType: 'タイプ：',
    bonusAmount: '賞金：',
    totalCount: '全 {total} 件',
    myTeam: '私のチーム',
    selectTeam: 'チームを選択してください',
    predictMatch: '試合',
    winTeam: '優勝チーム',
    predictResult: '賭けの結果',
    hit: '正しく推測されました',
    miss: '推測ではありません',
    draw: '引き分け',
    exchangeItem: 'アイテム交換',
    contactInfo: '連絡先',
    exchangeStatus: '引き換えステータス',
    currentRank: '現在のランキング',
    notJoinedTeam: 'チーム未加入',
    memberContribution: 'メンバーの貢献',
    teamTaskContribution: 'チームタスクへの貢献',
    loading: '読み込み中...',
    statusDone: '完了',
    statusPending: '処理',
    statusFail: '引き換えに失敗しました',
    logCompleteKyc: '完全なKYC',
    logExchangePrize: '賞品の引き換え',
    logMatchPredict: '試合の賭け',
    logDailySign: '毎日のチェックイン',
    logFinishTask: 'タスクを完了する',
    taskFirstRecharge: '最初の入金を完了する >= {amount} USDT',
    pagerTotal: '合計 {total} 個のアイテム',
    prevPage: '前のページへ',
    nextPage: '次のページ',
    goTo: 'に行く',
    page: 'ページ',
  },
  mobile: {
    title: 'ワールドカップの賭け',
  },
  nav: {
    entry: 'ワールドカップの賭け',
  },
  mock: {
    korea: '韓国',
    germany: 'ドイツ',
    china: '中国',
    uk: 'イギリス',
    france: 'フランス',
    portugal: 'ポルトガル',
    senegal: 'セネガル',
    brazil: 'ブラジル',
    india: 'インド',
    turkiye: 'トゥルキエ',
    usa: 'アメリカ合衆国',
    jerseyPack: 'オフィシャルジャージセット',
    vipCard: 'VIP暗号化会員カード',
    jerseyKeyword: 'ジャージー',
  },
  predict: {
    round: {
      group: 'グループステージ',
      r32: 'ラウンド 32',
      r16: 'ラウンド 16',
      quarter: '準々決勝',
      semi: '準決勝',
      third: '３位決定戦',
      final: '決勝戦',
    },
    status: {
      joined: 'すでに参加しています',
      open: '開ける',
      ongoing: '試合中',
      ended: '終わった',
    },
    btn: {
      joined: 'すでに賭けています',
      open: '{betPaymentAmount}USDT 今すぐベット',
      ongoing: 'ゲームが進行中です',
      ended: '賭けは終了しました',
    },
    joinedMatchPhase: {
      pending: '未開始',
      ongoing: '進行中',
      ended: '終了',
    },
    joinedResult: {
      hit: '的中 +{points}',
      missPrefix: '外れ',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: '資金源',
    poolSplit: '賞金プールの共有',
    teamIntro: 'チームの説明',
    poolRulesTitle: '賞金プールの説明',
    teamRulesTitle: 'チームの説明',
    predictRulesTitle: '賭けの指示',
    exchangeRulesTitle: '引き換え手順',
  },
  rulesText: {
    poolDesc1: 'イベントの初回ボーナスは {initialFunds} USDT です。イベントの有効期間中、ビジネスボーナスの一部は、賞金総額の継続的な増加に比例して賞金プールに投資されます。',
    poolLine1: '各リチャージ金額の {rechargePercentageToPool}% が自動的に賞金プールに追加されます。',
    poolLine2: '各無期限（先物）契約取引手数料の{contractFeePercentageToPool}%が自動的に賞金プールに入金されます。',
    poolLine3: '有効なユーザーが招待されるたびに、賞金プールは自動的に {additionalAmountPerValidUser} USDT ずつ増加します。',
    poolLine4: '*0.01 USDT 未満は賞金プールに計上されません。',
    teamPoolTitle: 'チームで賞金プールを分配',
    teamPoolRuleTitle: 'チーム分配ルール',
    teamPoolRule1: 'チームが賞金を獲得した後、キャプテン（フリーチームを除く）は分配賞金の20%を受け取ります。キャプテン報酬 = 総賞金プール × 今回の分配比率 × 20%',
    teamPoolRule2: '分配資格のあるチームメンバーは、個人ポイントの貢献度に応じて報酬を分配します。メンバー報酬 = [(総賞金プール × 今回のチーム分配比率) × (1 - 0.2) / 分配資格のあるチームメンバーのポイント合計] × 個人総ポイント',
    userPoolTitle: '個人ユーザーの賞金プール分配ルール',
    poolSplit1: '1回目：ベスト8確定後、ポイント1位のチームが賞金プールの {percentage}% を分配、残りは継続して積み上げ',
    poolSplit2: '2回目：ベスト4確定後、ポイント1位のチームが賞金プールの {percentage}% を分配、残りは継続して積み上げ',
    poolSplit3: '3回目：準決勝終了後、ポイント1位のチームが賞金プールの {percentage}% を分配、残りは継続して積み上げ',
    poolSplit4: '最終：決勝終了後、ポイント1位のチームが賞金プール全体の {percentage}% を分配。分配終了後、チームメンバーの利用可能ポイントはゼロにリセットされます',
    userPoolLine1: 'ゲームの終了時に、優勝を正しく推測したユーザーは、賞金プールを個別に共有する資格を与えられます。',
    userPoolLine2: '勝者を予想したすべてのユーザーは、個人ポイントの合計に基づいて賞金プールの {percentage}% を共有します。分配終了後、個人の利用可能ポイントはゼロにリセットされます。',
    poolFormula: '*例：あるチームで分配資格のあるユーザーが N 人おり、各ユーザーのポイントを N1、N2、N3...Nn、分配時の総賞金プールを A、当回の分配比率を 20%、隊長報酬比率を 20% とすると、チームメンバー報酬 = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*個人総ポイント',
    teamRule1: '1. 第一レベルのエージェントのみがチーム編成を開始できます。エージェントではない場合は、エージェントになることを申請してチームを結成することができます。',
    teamRule2: '2. エージェントではなく、エージェント資格を取得できない場合でも、プラットフォームが設​​定する無料チームに参加できます（エージェントではないユーザー）',
    teamRule3: '3. エージェントがチームを形成すると、エージェントとそのチームメンバーは自動的にチームになります。',
    teamRule4: '4.チーム合計ポイント = チームメンバー合計ポイント + チームタスク報酬ポイント',
    teamRule5: '5. 賞金プールを共有するチームメンバーの資格要件: イベント中に {quizTimesThreshold} 回以上の推測に参加 + 無期限（先物）契約取引量 ≥ {poolContractThreshold}U',
    predictRule1: '1. 競技開始後、賭けは終了します。',
    predictRule2: '2. 各ユーザーは、ゲームごとに 1 回だけ推測に参加できます。',
    predictRule3: '3. 賭けには {betPaymentAmount} USDT を支払う必要があります',
    predictRule4: '4. 勝利チームを正しく当てると +{correctBonusPoints} ポイント、間違って当てると +{wrongBonusPoints} ポイント',
    predictRule5: '5. 試合（グループステージ）が「引き分け」の場合、ポイントは誤った推測に基づいて計算され、+{wrongBonusPoints} ポイントとなります。',
    exchangeRule1: '1. 賞品の数には限りがあり、在庫がなくなり次第引き換えられます。早い者勝ちです。',
    exchangeRule2: '2. 賞品を引き換えた後、対応するポイントが差し引かれ、それに応じてチームのポイントも差し引かれます。',
    exchangeRule3: '3. 賞品を引き換える際に連絡先情報を入力してください。その後の賞品配布に関する事項についてプラットフォームのスタッフが連絡します。',
    exchangeRule4: '4. 引き換え時にご入力いただいた連絡先情報に誤りがあった場合、賞品の引き換えが妨げられる場合がございます。しっかりと確認し、引き続きニュースに注目してください。',
    exchangeRule5: '5. プラットフォームから長期間連絡がない場合は、プラットフォームのカスタマーサービスに連絡して処理してください。',
    timeTitle: '活動時間',
    activePeriodLabel: 'アクティビティ有効時間:',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: 'ポイントはイベント開始後にのみ計算および集計され、賞金プールが蓄積され始めます。',
    predictPeriodLabel: '賭け時間:',
    predictPeriodValue: 'チャンピオンベッティング: {startTime} ~ {endTime}',
    businessTitle: 'ビジネスルール',
    businessRule1: '1. 有効な招待ユーザー: 有効な招待とは、招待者のリチャージが {inviteRechargeThreshold}U 以上で、無期限（先物）契約取引量が {contractVolumeThreshold}U 以上であることを意味します。',
    businessRule2: '2. 賞金プールを共有するチームメンバーの資格要件: イベント中に {quizTimesThreshold} 回以上の予想に参加 + 無期限（先物）契約取引量 ≥ {poolContractThreshold}U',
    businessRule3: '3. 個人ポイントはいつでもギフトと交換できます。引き換え後、対応する個人ポイントとチームポイントが差し引かれます。',
    businessRule4: '4. 物理的な賞品の数には限りがあるため、在庫があるうちに引き換える必要があります。',
    businessRule5: '5. ワールドカップチケットの引き換え期限はワールドカップ開幕前日です。不可抗力により物理的なチケットを引き換えることができない場合は、同等の USDT と引き換えることができます。',
    statementTitle: '厳粛な声明',
    statement1: '1. 各ユーザーは、アクティビティに参加するために 1 つのアカウントのみを使用できます。複数のアカウント（一括登録アカウント、関連アカウントなどを含みますがこれらに限定されません）を使用してアクティビティに参加することは固く禁止されています。システムは、参加しているアカウントのログイン デバイスと IP アドレスを監視します。複数のアカウントが同じデバイスまたは同じ IP アドレスを使用して動作していることが判明した場合、プラットフォームはそれを関連アカウントとして判断する権利を有します。',
    statement2: '2. アクティビティに参加するユーザーの取引行動は真実かつ正当である必要があり、いかなる形式の逆取引、反対取引、または自己取引も固く禁じられています。',
    statement3: '3. プラットフォームは、リスク管理システムを通じて異常な取引行動を特定します。これには、高頻度のポジションのリバースオープンとクローズ、同じ価格でのヘッジ取引、および低リスクの裁定ウォッシュ行動が含まれますが、これらに限定されません。',
    statement4: '4. 異常な取引行為が発見された場合、プラットフォームは、取引のこの部分によって生成されたポイントをクリアし、アクティビティに参加するユーザーの資格を取り消し、関連する報酬を凍結または撤回する権利を有します。',
    statement5: '5. 賞金総額と報酬の分配は、プラットフォームの最終統計結果に従うものとします。プラットフォームは、このイベントのルールを最終的に解釈する権利を留保します。',
  },
  exchange: {
    needPoints: '必要ポイント',
    stock: '残り在庫',
    buyNow: '今すぐ引き換える',
    soldOut: '完売',
    badgeUnique: '当サイト唯一の大賞',
    badgeOnlyCount: '残り{count}件',
    itemFinalTicket: 'ワールドカップ決勝チケット',
    itemSignedFootball: 'サイン入りサッカーボール',
  },
  task: {
    earnPoints: 'ポイントを獲得する',
    goFinish: '完了する',
    goTeamTask: 'タスクでチームポイントを獲得',
  },
  taskGroup: {
    daily: '日々のタスク',
    invite: 'タスクを招待する',
    recharge: 'リチャージタスク',
    teamTrade: 'チームトレーディングタスク',
    dailyLimitPrefix: '1日の報酬制限',
    teamLimitPrefix: 'チームの 1 日あたりの報酬制限',
    limitPoints: '{num}ポイント',
    limitSuffix: '、毎日 00:00:00 (GMT+08:00) に更新されます。',
    rechargeLimitSuffix: 'イベント期間中の初回チャージのみ、基準を満たすかどうかの集計対象となります。',
    inviteCta: '今すぐ招待してポイントを獲得しましょう',
    taskPredictOnce: 'イベントベッティングに参加するたびに',
    taskTrade10000: '各累積完了の無期限（先物）契約取引量は {tradeVolume}U',
    taskInviteValidUser: '有効なユーザーの招待が完了するたびに',
    taskInviteRegister: '友達を招待して登録してください',
    taskInviteKyc: '友人を招待してKYCを完了してください',
    taskInviteRecharge: '友達を招待して最初のリチャージを完了してください',
    taskFirstRecharge: '最初の入金 >= {amount} USDT',
    taskTeamTrade10000: '完了した累積 {tradeVolume} USDT 無期限（先物）契約取引量ごとに、チームは +{teamBonusPoints} ポイントを受け取ります。',
  },
};
export {
    apis,
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};




// WEBPACK FOOTER //
// ./src/i18n/lang/public/ja_JP.js